import { useTranslation } from "@msuite/ui/localization";
import { DataTable } from "@msuite/ui/table";
import { useIncomingInvoiceDefaultApprovers } from "@/hooks/use-incoming-invoice-default-approvers";
import { useWorkspaces } from "@/hooks/use-workspaces";
import { toInvoiceDefaultApproverSets } from "./invoice-default-approver-sets";
import { columns } from "./invoice-default-approvers-table-config";

export function InvoiceDefaultApprovers() {
	/** Context */
	const { t } = useTranslation();

	/** Query */
	const { defaultApprovers, isLoading, queryKey, refetch } = useIncomingInvoiceDefaultApprovers();
	const { workspaces, isLoading: isLoadingWorkspaces } = useWorkspaces();

	/** Computed */
	const sets = toInvoiceDefaultApproverSets(
		t("incoming_invoices.organization_approvers"),
		workspaces,
		defaultApprovers,
	);

	/** Render */
	return (
		<DataTable
			data={sets}
			columns={columns}
			isLoading={isLoading || isLoadingWorkspaces}
			queryKey={queryKey}
			refetch={refetch}
			menu={null}
			persistenceKey="organization-invoice-default-approvers-table"
			initialPinningState={{ start: ["name"] }}
		/>
	);
}
